export class EsprimeAnalyer {

  /**
   * MemberExpression
   */
  public static analyMemberExpression(e: any): string {
    let identifier = "";

    if (e.type == "MemberExpression") {
      let obj = e.object;
      let pro = e.property;

      if (obj.type == "MemberExpression") {
        let prefix = this.analyMemberExpression(obj);
        identifier = identifier == "" ? prefix : identifier = prefix + "." + identifier;
      } else if (obj.type == "Identifier") {
        identifier = identifier == "" ? obj.name : identifier + "." + obj.name;
      }

      if (pro.type == "Identifier") {
        if (e.computed == true) {
          identifier = identifier == "" ? pro.name : identifier + "[" + pro.name + "]";
        } else {
          identifier = identifier == "" ? pro.name : identifier + "." + pro.name;
        }
      } else if (pro.type == "Literal") {
        if (e.computed == true) {
          identifier = identifier == "" ? pro.raw : identifier + "[" + pro.raw + "]";
        } else {
          identifier = identifier == "" ? pro.raw : identifier + "." + pro.raw;
        }
      }
    }

    return identifier;
  }

  /**
   * VariableDeclaration
   */
  public static analyVariableDeclaration(e: any) {
    let varInfo: Array<{ symbol: any, type: any, value: any }> = [];

    if (e.type == "VariableDeclaration") {
      if (e.declarations != null && e.declarations.length != 0) {
        for (let i = 0; i < e.declarations.length; i++) {
          let ele = e.declarations[i];
          if (ele.type == "VariableDeclarator") {
            let info = {
              symbol: ele.id.name,
              type: null,
              value: null
            }

            let init = ele.init;
            if (init != null) {
              if (init.type == "Literal") {
                info.type = "Literal";
                info.value = init.raw;
              } else if (init.type == "Identifier") {
                info.type = "Identifier";
                info.value = init.name;
              } else if (init.type == "MemberExpression") {
                info.value = this.analyMemberExpression(init);
              } else if (init.type == "ConditionalExpression") {
                this.cycleAnalyConditionalExpression(init, varInfo);
              }
            }

            varInfo.push(info);
          }
        }
      }
    }

    return varInfo;
  }

  /**
   * ReturnStatement
   * symbol: 变量信息
   * type: 变量类型(Literal字符，Identifier变量)
   */
  public static analyReturnStatement(e: any) {
    let ids: Array<{ symbol: any, type: any }> = [];

    if (e.type == "ReturnStatement") {
      //argument包含属性
      let arg = e.argument;;
      if (arg.type == "Literal") {
        let info = {
          symbol: arg.raw,
          type: arg.type,
        }

        ids.push(info);
      } else if (arg.type == "Identifier") {
        let info = {
          symbol: arg.name,
          type: arg.type,
        }

        ids.push(info);
      } else if (arg.type == "BinaryExpression") {
        this.cycleAnalyReturn(arg, ids);
      } else if (arg.type == "MemberExpression") {
        let id = this.analyMemberExpression(arg);
        let info = {
          symbol: id,
          type: "Identifier",
        }

        ids.push(info);
      } else if (arg.type == "ConditionalExpression") {
        this.cycleAnalyConditionalExpression(arg, ids);
      } else if (arg.type == "UnaryExpression") {
        let res = this.analyUnaryExpression(arg);
        ids = ids.concat(res);
      } else if (arg.type == "LogicalExpression") {
        let res = this.analyLogicalExpression(arg);
        ids = ids.concat(res);
      } else if (arg.type == "CallExpression") {
        let res = this.analyCallExpression(arg);
        ids = ids.concat(res);
      }
    }

    return ids;
  }
  private static cycleAnalyReturn(e: any, infos: any) {
    if (e.type == "BinaryExpression") {
      let left = e.left;
      let right = e.right;

      if (left.type == "BinaryExpression") {
        this.cycleAnalyReturn(left, infos);
      } else if (left.type == "Identifier") {
        let info = {
          symbol: left.name,
          type: left.type,
        }

        infos.push(info);
      } else if (left.type == "Literal") {
        let info = {
          symbol: left.raw,
          type: left.type,
        }

        infos.push(info);
      } else if (left.type == "MemberExpression") {
        let id = this.analyMemberExpression(left);
        let info = {
          symbol: id,
          type: "Identifier",
        }

        infos.push(info);
      }

      if (right.type == "Identifier") {
        let info = {
          symbol: right.name,
          type: right.type,
        }

        infos.push(info);
      } else if (right.type == "Literal") {
        let info = {
          symbol: right.raw,
          type: right.type,
        }

        infos.push(info);
      } else if (right.type == "MemberExpression") {
        let id = this.analyMemberExpression(right);
        let info = {
          symbol: id,
          type: "Identifier",
        }

        infos.push(info);
      } else if (right.type == "ConditionalExpression") {
        this.cycleAnalyConditionalExpression(right, infos);
      }
    }
  }

  /**
   * AssignmentExpression
   */
  public static analyAssignmentExpression(e: any) {
    let ids: Array<{ symbol: any, type: any }> = [];
    if (e.type == "AssignmentExpression") {
      let ele;
      ele = e.left;

      //分析left
      if (ele.type == "Identifier") {
        this.addIdentifier(ele, ids);
      } else if (ele.type == "Literal") {
        this.addLiteral(ele, ids);
      } else if (ele.type == "ConditionalExpression") {
        this.cycleAnalyConditionalExpression(ele, ids);
      } else if (ele.type == "CallExpression") {
        this.cycleAnalyCallExpression(ele, ids);
      }

      //分析right
      ele = e.right;
      if (ele.type == "Identifier") {
        this.addIdentifier(ele, ids);
      } else if (ele.type == "Literal") {
        this.addLiteral(ele, ids);
      } else if (ele.type == "ConditionalExpression") {
        this.cycleAnalyConditionalExpression(ele, ids);
      } else if (ele.type == "CallExpression") {
        this.cycleAnalyCallExpression(ele, ids);
      }
    }

    return ids;
  }

  /**
   * CallExpression
   */
  public static analyCallExpression(e: any) {
    let ids: Array<{ symbol: any, type: any }> = [];
    this.cycleAnalyCallExpression(e, ids);
    return ids;
  }
  private static cycleAnalyCallExpression(e: any, ids: any) {
    if (e.type == "CallExpression") {
      //callee
      if (e.callee.type == "MemberExpression") {
        let id = this.analyMemberExpression(e.callee);
        ids.push({ symbol: id, type: null });
      } else if (e.callee.type == "Identifier") {
        this.addIdentifier(e.callee, ids);
      }

      //arguments
      for (let i = 0; i < e.arguments.length; i++) {
        let arg = e.arguments[i];
        if (arg.type == "MemberExpression") {
          let id = this.analyMemberExpression(arg);
          ids.push({ symbol: id, type: null });
        } else if (arg.type == "CallExpression") {
          this.cycleAnalyCallExpression(arg, ids);
        } else if (arg.type == "BinaryExpression") {
          this.cycleAnalyBinaryExpression(arg, ids);
        } else if (arg.type == "Identifier") {
          this.addIdentifier(arg, ids);
        } else if (arg.type == "Literal") {
          this.addLiteral(arg, ids);
        }
      }
    }
  }

  /**
   * BinaryExpression
   */
  public static analyBinaryExpression(e: any) {
    let ids: Array<{ symbol: any, type: any }> = [];
    if (e.type == "BinaryExpression") {
      let ele;

      //left
      ele = e.left;
      if (ele.type == "BinaryExpression") {
        this.cycleAnalyBinaryExpression(ele, ids);
      } else if (ele.type == "Identifier") {
        this.addIdentifier(ele, ids);
      } else if (ele.type == "Literal") {
        this.addLiteral(ele, ids);
      } else if (ele.type == "MemberExpression") {
        let id = this.analyMemberExpression(ele);
        ids.push({ symbol: id, type: null });
      } else if (ele.type == "CallExpression") {
        this.cycleAnalyCallExpression(ele, ids);
      } else if (ele.type == "UnaryExpression") {
        let res = this.analyUnaryExpression(ele);
        ids = ids.concat(res);
      }

      //right
      ele = e.right;
      if (ele.type == "BinaryExpression") {
        this.cycleAnalyBinaryExpression(ele, ids);
      } else if (ele.type == "Identifier") {
        this.addIdentifier(ele, ids);
      } else if (ele.type == "Literal") {
        this.addLiteral(ele, ids);
      } else if (ele.type == "MemberExpression") {
        let id = this.analyMemberExpression(ele);
        ids.push({ symbol: id, type: null });
      } else if (ele.type == "CallExpression") {
        this.cycleAnalyCallExpression(ele, ids);
      } else if (ele.type == "UnaryExpression") {
        let res = this.analyUnaryExpression(ele);
        ids = ids.concat(res);
      }
    }

    return ids;
  }
  private static cycleAnalyBinaryExpression(e: any, ids: any) {
    if (e.type == "BinaryExpression") {
      let ele;

      //分析左侧
      ele = e.left;
      if (ele.type == "BinaryExpression") {
        this.cycleAnalyBinaryExpression(ele, ids);
      } else if (ele.type == "Identifier") {
        this.addIdentifier(ele, ids);
      } else if (ele.type == "Literal") {
        this.addLiteral(ele, ids);
      } else if (ele.type == "MemberExpression") {
        let id = this.analyMemberExpression(ele);
        ids.push({ symbol: id, type: null });
      } else if (ele.type == "CallExpression") {
        this.cycleAnalyCallExpression(ele, ids);
      } else if (ele.type == "UnaryExpression") {
        let res = this.analyUnaryExpression(ele);
        ids = ids.concat(res);
      }

      //分析右侧
      ele = e.right;
      if (ele.type == "BinaryExpression") {
        this.cycleAnalyBinaryExpression(ele, ids);
      } else if (ele.type == "Identifier") {
        this.addIdentifier(ele, ids);
      } else if (ele.type == "Literal") {
        this.addLiteral(ele, ids);
      } else if (ele.type == "MemberExpression") {
        let id = this.analyMemberExpression(ele);
        ids.push({ symbol: id, type: null });
      } else if (ele.type == "CallExpression") {
        this.cycleAnalyCallExpression(ele, ids);
      } else if (ele.type == "UnaryExpression") {
        let res = this.analyUnaryExpression(ele);
        ids = ids.concat(res);
      }
    }
  }

  /**
   * IfStatement
   */
  public static analyIfStatement(e: any) {
    let ids: Array<{ symbol: any, type: any }> = [];
    if (e.type = "IfStatement") {
      //test 条件
      let test = e.test;
      //consequent 随之而来
      let consequent = e.consequent;
      //alternate 备选方案
      let alternate = e.alternate;

      //test
      if (test.type == "BinaryExpression") {
        this.cycleAnalyBinaryExpression(test, ids);
      } else if (test.type == "LogicalExpression") {
        let newIds = this.analyLogicalExpression(test);
        ids = ids.concat(newIds);
      } else if (test.type == "CallExpression") {
        this.cycleAnalyCallExpression(test, ids);
      }

      //consequent
      if (consequent != null && consequent.body != null && consequent.body.length > 0) {
        for (let i = 0; i < consequent.body.length; i++) {
          let ele = consequent.body[i];

          if (ele.type == "BinaryExpression") {
            this.cycleAnalyBinaryExpression(ele, ids);
          } else if (ele.type == "Identifier") {
            this.addIdentifier(ele, ids);
          } else if (ele.type == "Literal") {
            this.addLiteral(ele, ids);
          } else if (ele.type == "MemberExpression") {
            let id = this.analyMemberExpression(ele);
            ids.push({ symbol: id, type: null });
          } else if (ele.type == "IfStatement") {
            let newIds = this.analyIfStatement(ele);
            ids = ids.concat(newIds);
          } else if (ele.type == "ReturnStatement") {
            let newIds = this.analyReturnStatement(ele);
            ids = ids.concat(newIds);
          }
        }
      }

      //alternate
      if (alternate != null) {
        if (alternate.type == "IfStatement") {
          this.cycleAnalyIfStatement(alternate, ids);
        } else if (alternate.type == "BlockStatement") {
          if (alternate != null && alternate.body != null && alternate.body.length > 0) {
            for (let i = 0; i < alternate.body.length; i++) {
              let ele = alternate.body[i];

              if (ele.type == "BinaryExpression") {
                this.cycleAnalyBinaryExpression(ele, ids);
              } else if (ele.type == "Identifier") {
                this.addIdentifier(ele, ids);
              } else if (ele.type == "Literal") {
                this.addLiteral(ele, ids);
              } else if (ele.type == "MemberExpression") {
                let id = this.analyMemberExpression(ele);
                ids.push({ symbol: id, type: null });
              } else if (ele.type == "IfStatement") {
                let newIds = this.analyIfStatement(ele);
                ids = ids.concat(newIds);
              } else if (ele.type == "ReturnStatement") {
                let newIds = this.analyReturnStatement(ele);
                ids = ids.concat(newIds);
              }
            }
          }
        }
      }
    }

    return ids;
  }
  private static cycleAnalyIfStatement(e: any, ids: any) {
    if (e.type = "IfStatement") {
      let test = e.test;
      let consequent = e.consequent;
      let alternate = e.alternate;

      if (test.type == "BinaryExpression") {
        this.cycleAnalyBinaryExpression(test, ids);
      } else if (test.type == "LogicalExpression") {
        let newIds = this.analyLogicalExpression(test);
        ids = ids.concat(newIds);
      } else if (test.type == "CallExpression") {
        this.cycleAnalyCallExpression(test, ids);
      }
      if (consequent != null && consequent.body != null && consequent.body.length > 0) {
        for (let i = 0; i < consequent.body.length; i++) {
          let ele = consequent.body[i];

          if (ele.type == "BinaryExpression") {
            this.cycleAnalyBinaryExpression(ele, ids);
          } else if (ele.type == "Identifier") {
            this.addIdentifier(ele, ids);
          } else if (ele.type == "Literal") {
            this.addLiteral(ele, ids);
          } else if (ele.type == "MemberExpression") {
            let id = this.analyMemberExpression(ele);
            ids.push({ symbol: id, type: null });
          } else if (ele.type == "IfStatement") {
            let newIds = this.analyIfStatement(ele);
            ids = ids.concat(newIds);
          } else if (ele.type == "ReturnStatement") {
            let newIds = this.analyReturnStatement(ele);
            ids = ids.concat(newIds);
          }
        }
      }
      if (alternate != null) {
        if (alternate.type == "IfStatement") {
          this.cycleAnalyIfStatement(alternate, ids);
        } else if (alternate.type == "BlockStatement") {
          if (alternate != null && alternate.body != null && alternate.body.length > 0) {
            for (let i = 0; i < alternate.body.length; i++) {
              let ele = alternate.body[i];

              if (ele.type == "BinaryExpression") {
                this.cycleAnalyBinaryExpression(ele, ids);
              } else if (ele.type == "Identifier") {
                this.addIdentifier(ele, ids);
              } else if (ele.type == "Literal") {
                this.addLiteral(ele, ids);
              } else if (ele.type == "MemberExpression") {
                let id = this.analyMemberExpression(ele);
                ids.push({ symbol: id, type: null });
              } else if (ele.type == "IfStatement") {
                let newIds = this.analyIfStatement(ele);
                ids = ids.concat(newIds);
              } else if (ele.type == "ReturnStatement") {
                let newIds = this.analyReturnStatement(ele);
                ids = ids.concat(newIds);
              }
            }
          }
        }
      }
    }
  }

  /**
   * LogicalExpression
   */
  public static analyLogicalExpression(e: any) {
    let ids: Array<{ symbol: any, type: any }> = [];
    if (e.type == "LogicalExpression") {
      let ele;

      //left
      ele = e.left;
      if (ele.type == "LogicalExpression") {
        this.cycleAnalyLogicalExpression(ele, ids);
      } else if (ele.type == "BinaryExpression") {
        this.cycleAnalyBinaryExpression(ele, ids);
      } else if (ele.type == "Identifier") {
        this.addIdentifier(ele, ids);
      } else if (ele.type == "Literal") {
        this.addLiteral(ele, ids);
      } else if (ele.type == "MemberExpression") {
        let id = this.analyMemberExpression(ele);
        ids.push({ symbol: id, type: null });
      } else if (ele.type == "CallExpression") {
        this.cycleAnalyCallExpression(ele, ids);
      }

      //right
      ele = e.right;
      if (ele.type == "LogicalExpression") {
        this.cycleAnalyLogicalExpression(ele, ids);
      } else if (ele.type == "BinaryExpression") {
        this.cycleAnalyBinaryExpression(ele, ids);
      } else if (ele.type == "Identifier") {
        this.addIdentifier(ele, ids);
      } else if (ele.type == "Literal") {
        this.addLiteral(ele, ids);
      } else if (ele.type == "MemberExpression") {
        let id = this.analyMemberExpression(ele);
        ids.push({ symbol: id, type: null });
      } else if (ele.type == "CallExpression") {
        this.cycleAnalyCallExpression(ele, ids);
      }
    }

    return ids;
  }
  private static cycleAnalyLogicalExpression(e: any, ids: any) {
    if (e.type == "LogicalExpression") {
      let ele;

      //left
      ele = e.left;
      if (ele.type == "LogicalExpression") {
        this.cycleAnalyLogicalExpression(ele, ids);
      } else if (ele.type == "BinaryExpression") {
        this.cycleAnalyBinaryExpression(ele, ids);
      } else if (ele.type == "Identifier") {
        this.addIdentifier(ele, ids);
      } else if (ele.type == "Literal") {
        this.addLiteral(ele, ids);
      } else if (ele.type == "MemberExpression") {
        let id = this.analyMemberExpression(ele);
        ids.push({ symbol: id, type: null });
      } else if (ele.type == "CallExpression") {
        this.cycleAnalyCallExpression(ele, ids);
      }

      //right
      ele = e.right;
      if (ele.type == "LogicalExpression") {
        this.cycleAnalyLogicalExpression(ele, ids);
      } else if (ele.type == "BinaryExpression") {
        this.cycleAnalyBinaryExpression(ele, ids);
      } else if (ele.type == "Identifier") {
        this.addIdentifier(ele, ids);
      } else if (ele.type == "Literal") {
        this.addLiteral(ele, ids);
      } else if (ele.type == "MemberExpression") {
        let id = this.analyMemberExpression(ele);
        ids.push({ symbol: id, type: null });
      } else if (ele.type == "CallExpression") {
        this.cycleAnalyCallExpression(ele, ids);
      }
    }
  }

  /**
   * ConditionalExpression
   */
  public static analyConditionalExpression(e: any) {
    let ids: Array<{ symbol: any, type: any }> = [];
    if (e.type == "ConditionalExpression") {
      //test 条件
      let test = e.test;
      //consequent 随之而来
      let consequent = e.consequent;
      //alternate 备选方案
      let alternate = e.alternate;

      //test
      if (test.type == "BinaryExpression") {
        this.cycleAnalyBinaryExpression(test, ids);
      } else if (test.type == "LogicalExpression") {
        let newIds = this.analyLogicalExpression(test);
        ids = ids.concat(newIds);
      }

      //consequent
      if (consequent != null) {
        if (consequent.type == "ConditionalExpression") {
          this.cycleAnalyConditionalExpression(consequent, ids);
        } else if (consequent.type == "Identifier") {
          this.addIdentifier(consequent, ids);
        } else if (consequent.type == "Literal") {
          this.addLiteral(consequent, ids);
        } else if (consequent.type == "CallExpression") {
          this.cycleAnalyCallExpression(consequent, ids);
        }
      }

      //alternate
      if (alternate != null) {
        if (alternate != null) {
          if (alternate.type == "ConditionalExpression") {
            this.cycleAnalyConditionalExpression(alternate, ids);
          } else if (alternate.type == "Identifier") {
            this.addIdentifier(alternate, ids);
          } else if (alternate.type == "Literal") {
            this.addLiteral(alternate, ids);
          } else if (alternate.type == "CallExpression") {
            this.cycleAnalyCallExpression(alternate, ids);
          }
        }
      }
    }

    return ids;
  }
  private static cycleAnalyConditionalExpression(e: any, ids: any) {
    if (e.type == "ConditionalExpression") {
      let test = e.test;
      let consequent = e.consequent;
      let alternate = e.alternate;

      if (test.type == "BinaryExpression") {
        this.cycleAnalyBinaryExpression(test, ids);
      } else if (test.type == "LogicalExpression") {
        let newIds = this.analyLogicalExpression(test);
        ids = ids.concat(newIds);
      }
      if (consequent != null) {
        if (consequent.type == "ConditionalExpression") {
          this.cycleAnalyConditionalExpression(consequent, ids);
        } else if (consequent.type == "Identifier") {
          this.addIdentifier(consequent, ids);
        } else if (consequent.type == "Literal") {
          this.addLiteral(consequent, ids);
        } else if (consequent.type == "CallExpression") {
          this.cycleAnalyCallExpression(consequent, ids);
        }
      }
      if (alternate != null) {
        if (alternate != null) {
          if (alternate.type == "ConditionalExpression") {
            this.cycleAnalyConditionalExpression(alternate, ids);
          } else if (alternate.type == "Identifier") {
            this.addIdentifier(alternate, ids);
          } else if (alternate.type == "Literal") {
            this.addLiteral(alternate, ids);
          } else if (alternate.type == "CallExpression") {
            this.cycleAnalyCallExpression(alternate, ids);
          }
        }
      }
    }
  }

  /**
   * UnaryExpression
   */
  public static analyUnaryExpression(e: any) {
    let ids: Array<{ symbol: any, type: any }> = [];
    if (e.type == "UnaryExpression") {
      let argument = e.argument;

      if (argument.type == "Identifier") {
        this.addIdentifier(argument, ids);
      } else if (argument.type == "Literal") {
        this.addLiteral(argument, ids);
      } else if (argument.type == "LogicalExpression") {
        let newIds = this.analyLogicalExpression(argument);
        ids = ids.concat(newIds);
      }
    }

    return ids;
  }

  /**
   * ForStatement
   */
  public static analyForStatement(e: any) {
    let ids: Array<{ symbol: any, type: any }> = [];
    if (e.type == "ForStatement") {
      //TODO 处理更多
      let test = e.test;
      let body = e.body;

      if (test.type == "BinaryExpression") {
        let res = this.analyBinaryExpression(test);
        ids = ids.concat(res);
      }

      if (body.type == "BlockStatement") {
        for (let i = 0; i < body.body.length; i++) {
          let ele = body.body[i];

          if (ele.type == "Identifier") {
            this.addIdentifier(ele, ids);
          } else if (ele.type == "Literal") {
            this.addLiteral(ele, ids);
          } else if (ele.type == "VariableDeclaration") {
            let newIds = this.analyVariableDeclaration(ele);
            ids = ids.concat(newIds);
          } else if (ele.type == "ReturnStatement") {
            let newIds = this.analyReturnStatement(ele);
            ids = ids.concat(newIds);
          } else if (ele.type == "AssignmentExpression") {
            let newIds = this.analyAssignmentExpression(ele);
            ids = ids.concat(newIds);
          } else if (ele.type == "UnaryExpression") {
            let newIds = this.analyUnaryExpression(ele);
            ids = ids.concat(newIds);
          } else if (ele.type == "BinaryExpression") {
            this.cycleAnalyBinaryExpression(ele, ids);
          } else if (ele.type == "MemberExpression") {
            let id = this.analyMemberExpression(ele);
            ids.push({ symbol: id, type: null });
          } else if (ele.type == "ConditionalExpression") {
            let newIds = this.analyConditionalExpression(ele);
            ids = ids.concat(newIds);
          } else if (ele.type == "CallExpression") {
            let newIds = this.analyCallExpression(ele);
            ids = ids.concat(newIds);
          } else if (ele.type == "LogicalExpression") {
            let newIds = this.analyLogicalExpression(ele);
            ids = ids.concat(newIds);
          } else if (ele.type == "IfStatement") {
            let newIds = this.analyIfStatement(ele);
            ids = ids.concat(newIds);
          } else if (ele.type == "ForStatement") {
            let newIds = this.analyForStatement(ele);
            ids = ids.concat(newIds);
          }
        }
      }
    }

    return ids;
  }


  private static addIdentifier(e: any, ids: any) {
    if (e.type == "Identifier") {
      let info = {
        symbol: e.name,
        type: e.type,
      }

      ids.push(info);
    }
  }

  private static addLiteral(e: any, ids: any) {
    if (e.type == "Literal") {
      let info = {
        symbol: e.raw,
        type: e.type,
      }

      ids.push(info);
    }
  }

  public static analyIdentifier(e: any) {
    let ids: Array<{ symbol: any, type: any }> = [];
    if (e.type == "Identifier") {
      this.addIdentifier(e, ids);
    }

    return ids;
  }

  public static analyLiteral(e: any) {
    let ids: Array<{ symbol: any, type: any }> = [];
    if (e.type == "Literal") {
      this.addLiteral(e, ids);
    }

    return ids;
  }

}